import React, { CSSProperties, PropsWithChildren, useContext, useLayoutEffect } from 'react'
import { MultiPaneLayoutContext } from '../multipPaneLayout.context'
import useStyles from './styles'
import { useSelector } from 'react-redux'
import { selectWidgetPaneId } from '../../../selectors/common'
import {
    getDashboardFocusedSlot,
    isDashboardPaneHighlightEnabled
} from '../../widgetDashboard/dashboardFocusedSlotStore'

export type SlotContainerProps = {
    paneId: number
}

/** Pane highlight is applied imperatively via dashboardFocusedSlotStore — not React state — so Redux/stock-bar re-renders cannot delay or wipe it. */
const SlotContainer: React.FC<PropsWithChildren<SlotContainerProps>> = ({ paneId, children }) => {
    const layoutContext = useContext(MultiPaneLayoutContext)
    const slotStyles = layoutContext.paneStyles[paneId]
    const { classes } = useStyles()
    const widgetPaneId = useSelector(selectWidgetPaneId)
    const isFullscreen = widgetPaneId === paneId
    useLayoutEffect(() => {
        if (getDashboardFocusedSlot() === paneId && isDashboardPaneHighlightEnabled()) {
            document.getElementById(`slot-${paneId}`)?.setAttribute('data-pane-active', 'true')
        }
    }, [paneId])
    const style: CSSProperties = {
        width: isFullscreen ? '100%' : `${slotStyles?.width || 0}px`,
        height: isFullscreen ? '100%' : `${slotStyles?.height || 0}px`,
        left: isFullscreen ? '0%' : `${slotStyles?.left || 0}px`,
        top: isFullscreen ? '0%' : `${slotStyles?.top || 0}px`,
        zIndex: isFullscreen ? 999 : 'auto'
    }
    return (
        <div className={classes.container} style={style} id={`slot-${paneId}`}>
            {slotStyles && children}
        </div>
    )
}

export default SlotContainer